export var IconType;
(function (IconType) {
  IconType["plain"] = "plain";
  IconType["button"] = "button";
  IconType["textField"] = "textField";
})(IconType || (IconType = {}));
